import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
const toolTipContainer = document.getElementById('tooltipContainer');
export default class RelativePortal extends React.Component {
  static propTypes = {
    top: PropTypes.number,
    left: PropTypes.number,
    children: PropTypes.node.isRequired,
  };

  static defaultProps = {
    top: 0,
    left: 0,
  };

  constructor(props) {
    super(props);
    this.node = document.createElement('div');
  }

  state = {
    top: 0,
    left: 0,
  };

  componentDidMount() {
    toolTipContainer.appendChild(this.node);

    this.handleResize = () => {
      const rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
      const left = window.scrollX + rect.left;
      const top = window.scrollY + rect.top;

      if (top !== this.state.top || left !== this.state.left) {
        this.setState({ left, top });
      }
    };

    window.addEventListener('resize', this.handleResize);

    this.handleResize();
  }

  componentWillUnmount() {
    if (this.handleResize) {
      window.removeEventListener('resize', this.handleResize);
    }
    toolTipContainer.removeChild(this.node);
  }

  render() {
    const { children } = this.props;
    return (
      <div className="relative-portal">
        {ReactDOM.createPortal(
          <div
            {...this.props}
            className="relative-portal-container"
            style={{
              position: 'absolute',
              top: this.state.top + this.props.top,
              left: this.state.left + this.props.left,
            }}
          >
            {children}
          </div>,
          this.node,
        )}
      </div>
    );
  }
}
